import {supportsBimCad} from "./bimCadRequest";
import { useEffect, useState } from "react";
import type { CalculationTemplate } from "./types";

function material(template: CalculationTemplate) {
  const family = template.sourceCalculation?.materialFamily;
  if (family === "Pvc") return "ПВХ";
  if (family === "Aluminium") return "Алюминий";
  if (family === "Infill") return "Заполнение";
  if (/ALUTEX|TERMO LUX|TERMAL/i.test(template.profileSystem)) return "Алюминий";
  if (/GRAIN|NORDPROF|VEKTOR|BULAVA/i.test(template.profileSystem)) return "ПВХ";
  return "Другие";
}

export function MeasurementSystemPicker({ templates, constructionType, selectedId, disabled, onType, onSelect }: {
  templates: CalculationTemplate[]; constructionType: string; selectedId: string; disabled: boolean;
  onType: (value: string) => void; onSelect: (id: string) => void;
}) {
  const selected = templates.find(item => item.id === selectedId);
  const [family, setFamily] = useState(selected ? material(selected) : "");
  useEffect(() => { setFamily(""); }, [constructionType]);
  useEffect(() => { if (selected) setFamily(material(selected)); }, [selected?.id]);
  const types = [...new Set(templates.map(item => item.constructionType))];
  const typed = templates.filter(item => item.constructionType === constructionType);
  const families = [...new Set(typed.map(material))].sort((a,b) => a.localeCompare(b,"ru"));
  const choices = typed.filter(item => !family || material(item) === family)
    .sort((a,b) => a.profileSystem.localeCompare(b.profileSystem,"ru"));
  const available = choices.filter(item => item.technicalReadiness?.ready || item.sourceCalculation?.available);
  const sketchOnly = choices.filter(item => !available.includes(item));
  return <div className="system-picker">
    <label className="field"><span>Материал</span><select value={family} disabled={disabled || !constructionType} onChange={event => {
      const next = event.target.value; setFamily(next);
      if (selected && next && material(selected) !== next) onSelect("");
    }}><option value="">Все материалы</option>{families.map(item => <option key={item}>{item}</option>)}</select></label>
    <div className="profile-system-buttons" role="group" aria-label="Профильная система">{choices.map(item=><button type="button" key={item.id} disabled={disabled||!constructionType} aria-pressed={selectedId===item.id} onClick={()=>onSelect(item.id)}><strong>{item.profileSystem}</strong>{!available.includes(item)&&<small>{supportsBimCad(item.id)?"CAD по BIM · расчёт не утверждён":"Только эскиз"}</small>}</button>)}</div>
  </div>;
}
